export const VEHICLE_IMAGES = {
  car: "https://www.packky.com/images/Vechiles/four_wheeler.webp",
  truck: "https://www.packky.com/images/Vechiles/mini_truck.webp",
  auto: "https://www.packky.com/images/Vechiles/three_wheeler.webp",
  bike: "https://www.packky.com/images/Vechiles/two_wheeler.webp",
};